import React from 'react';
import Image from 'next/image';
import { isVideoLink } from '@/lib/utils/helpers';
import styles from './Media.module.css';

type MediaProps =
  Partial<Pick<HTMLDivElement, 'className'>>
  & Partial<Pick<HTMLVideoElement, 'autoplay'>>
  & {
  priority?: boolean;
  media_url?: string;
};

const Media = React.forwardRef<HTMLVideoElement, MediaProps>(
  (
    {
      media_url,
      priority = false,
      autoplay = false,
      className = '',
    },
    ref,
  ): React.ReactElement => {
    const getLogoElement = () => {
      if (!isVideoLink(media_url)) {
        return (
          <Image
            className={styles.media}
            src={media_url || ''}
            alt="Collection logo"
            priority={priority}
            fill
          />
        );
      }

      return (
        <video
          className={styles.media}
          src={media_url}
          ref={ref}
          loop
          playsInline
          muted
          autoPlay={autoplay}
        />
      );
    };

    return (
      <div style={{ position: 'relative' }} className={className}>
        {getLogoElement()}
      </div>
    );
  },
);

export default Media;
